import React, { Component } from 'react';

import { extractImage, BACKGROUND } from '../../lib/image-versions';

class BackgroundImage extends Component {
  getImageUrl() {
    const image = extractImage(this.props.images, BACKGROUND, this.props.defaultImageUrl);
    return image.url;
  }

  getImageStyle() {
    return { backgroundImage: `url(${this.getImageUrl()})` };
  }

  render() {
    return (
      <div
        className="background-image dashboard-background"
        style={this.getImageStyle()}
      />
    );
  }
}


BackgroundImage.defaultProps = {
  images: [],
};

export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/background-image.js